"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginHelperServiceImpl = void 0;
const Types_1 = require("../../Types");
const core_1 = require("@athena-portal/core");
const moment_1 = __importDefault(require("moment"));
const rxjs_1 = require("rxjs");
const core_2 = require("@athena-portal/core");
const operators_1 = require("rxjs/operators");
let PluginHelperServiceImpl = class PluginHelperServiceImpl {
    getActiveTempDriversInfoFromPolicyHistory(currentPolicies) {
        const promisses = [];
        const POLICY_STATUS_MTA = `MTA`;
        let activePolicyHistoryList = [];
        for (const currentPolicy of currentPolicies) {
            if (currentPolicy.policyHistoryList) {
                activePolicyHistoryList = [...activePolicyHistoryList, ...currentPolicy.policyHistoryList.filter((ph) => (0, moment_1.default)(ph.endDate).isAfter((0, moment_1.default)()))];
            }
        }
        for (const currentPolicy of currentPolicies) {
            if (activePolicyHistoryList && activePolicyHistoryList.length !== 0) {
                const currentActivePolicyHistoryList = activePolicyHistoryList.filter((ph) => currentPolicy.interaction.agreementVersionId >= ph.id);
                currentActivePolicyHistoryList.sort((b, a) => a.number - b.number);
                const policyVersionIds = [];
                for (const activePolicyHistory of currentActivePolicyHistoryList) {
                    if (activePolicyHistory.status === POLICY_STATUS_MTA) {
                        policyVersionIds.push(activePolicyHistory.id);
                    }
                    else {
                        break;
                    }
                }
                if (policyVersionIds) {
                    for (const id of policyVersionIds) {
                        promisses.push(this.customerPortalService.getPoliciesByPolicyVersionId(id).pipe((0, operators_1.map)((policy) => {
                            return {
                                policy,
                                currentPolicy
                            };
                        })).toPromise());
                    }
                }
            }
        }
        return (0, rxjs_1.from)(Promise.all(promisses).then((policyMap) => {
            const tempDrivers = new Map();
            policyMap.forEach((pol) => {
                if (pol.policy && pol.policy.interaction && pol.policy.interaction.temporaryDrivers) {
                    const tempDriver = pol.policy.interaction.temporaryDrivers[0];
                    for (const mtaVehicle of pol.policy.interaction.vehicles) {
                        for (const vehicle of pol.currentPolicy.interaction.vehicles) {
                            if (vehicle.registrationNumber === mtaVehicle.registrationNumber && mtaVehicle.driverIds.includes(tempDriver.personId)) {
                                tempDriver.mainDriver = mtaVehicle.mainDriverId === tempDriver.personId ? true : false;
                                tempDrivers.set(vehicle.registrationNumber, tempDriver);
                            }
                        }
                    }
                }
            });
            return tempDrivers;
        }));
    }
};
exports.PluginHelperServiceImpl = PluginHelperServiceImpl;
__decorate([
    (0, core_1.lazyInject)(Types_1.Types.CustomerPortalService),
    __metadata("design:type", Object)
], PluginHelperServiceImpl.prototype, "customerPortalService", void 0);
exports.PluginHelperServiceImpl = PluginHelperServiceImpl = __decorate([
    (0, core_2.injectable)()
], PluginHelperServiceImpl);
//# sourceMappingURL=PluginHelperServiceImpl.js.map